import React, { type ReactNode } from 'react';
import clsx from 'clsx';
import { getRtmEnrollmentStyles } from 'components/rtmEnrollment/rtmEnrollmentStyles';

type CalloutProps = {
  children: ReactNode;
};

export default function Callout({ children }: CalloutProps) {
  const styles = getRtmEnrollmentStyles();

  return (
    <div className={clsx(styles.space.callout, styles.type.callout)}>
      {children}
    </div>
  );
}
